// Shows matched from tape track titles (coverage SPEC section 7). In a
// setlist band, a date with tapes but no setlist can still be searched: its
// songs come from the best tape's track titles. Those shows carry
// `source: 'tracks'` (ShowSummary) or `fromTape: true` (song page endpoints)
// and, on ShowSummary, `tapeMatch: { songTracks, recTracks, complete }`.
//
// Every list that shows such a show adds a small "From tape" badge. In a
// band searched only from tape titles (meta.mode 'tracks') every show is
// from tape, so the badge would say nothing and is left out there.
// Missing fields fall back to today's look, so this works with old data.

import React from 'react';
import { IconNote } from './icons';
import { plural } from './search/util';

// The band mixes setlist shows with shows matched from tape titles.
export const isFillBand = (meta) => !!(meta && meta.mode === 'setlist' && meta.features && meta.features.tracksFill);

// This show (ShowSummary, find row or song endpoint) was matched from tape titles.
export const isFromTape = (row) => !!(row && (row.source === 'tracks' || row.fromTape === true));

const validMatch = (tm) =>
  !!(tm && Number.isFinite(Number(tm.songTracks)) && Number(tm.songTracks) > 0 && Number.isFinite(Number(tm.recTracks)));

// "13 of 16 song tracks named", or '' when the counts are missing.
export const tapeMatchText = (tm) =>
  validMatch(tm) ? Number(tm.recTracks).toLocaleString('en-US') + ' of ' + plural(Number(tm.songTracks), 'song track') + ' named' : '';

export const fromTapeTitle = (tm) => {
  const t = tapeMatchText(tm);
  return 'Matched from tape track titles' + (t ? ': ' + t : '') + '. No set order, opener or encore.';
};

// A venue line for a show with no venue. Find rows get 'Unknown' from
// api.adaptFindRow (kept so queue items and links stay the same).
export const noVenue = (v) => !v || v === 'Unknown';

// <FromTapeBadge row={row} className="ss-fromtape" />
export function FromTapeBadge({ row, className }) {
  return (
    <span className={'badge ' + (className || 'ss-fromtape')} title={fromTapeTitle(row && row.tapeMatch)}>
      <IconNote size={11} /> From tape
    </span>
  );
}
